<template>
    <form @submit.prevent="submit()" enctype="multipart/form-data">
        <!-- Name Field -->
        <div :class="{ 'has-error': errors.name }" class="form-group col-sm-6">
            <label for="name">
                Nombre:
            </label>
            <input class="form-control" id="name" type="text" v-model="data.name">
                <div class="help-block" v-if="errors.name">
                    {{ errors.name }}
                </div>
            </input>
        </div>
        <!-- Id Landing Pages Components Field -->
        <div :class="{ 'has-error': errors.id_landing_pages_components }" class="form-group col-sm-6">
            <label for="id_landing_pages_components">
                Componentes:
            </label>
            <select @change="onChangeComponents()" class="form-control" id="id_landing_pages_components" v-model="data.id_landing_pages_components">
                <option v-bind:value="{ id: component.id, text: component.component }" v-for="component in components" v-text="component.title">
                </option>
            </select>
            <div class="help-block" v-if="errors.id_landing_pages_components">
                {{ errors.id_landing_pages_components }}
            </div>
        </div>
        <!-- Active Field -->
        <div class="form-group col-sm-12">
            <label for="active">
                Activo?:
            </label>
            <br/>
            <label>
                <input id="active" type="checkbox" v-model="data.active" value="1">
                </input>
            </label>
        </div>
        <div id="components-1" v-if="showComponent == 'lp-components-3-text-description'">
            <div class="col-sm-12">
                <h4 class="panel-title">
                    Configuración para componente
                </h4>
                <hr/>
            </div>
            <!-- input_title_1 Field -->
            <div :class="{'has-error': errors.input_title_1}" class="form-group col-sm-4">
                <label for="input_title_1">
                    Título:
                </label>
                <input class="form-control" id="input_title_1" type="text" v-model="data.input_title_1">
                    <div class="help-block" v-if="errors.input_title_1">
                        {{ errors.input_title_1 }}
                    </div>
                </input>
            </div>
            <!-- input_button_1 Field -->
            <div :class="{'has-error': errors.input_button_1}" class="form-group col-sm-4">
                <label for="input_button_1">
                    Link:
                </label>
                <input class="form-control" id="input_button_1" type="text" v-model="data.input_button_1">
                    <div class="help-block" v-if="errors.input_button_1">
                        {{ errors.input_button_1 }}
                    </div>
                </input>
            </div>
            <!-- input_description_1 Field -->
            <div :class="{'has-error': errors.input_description_1}" class="form-group col-sm-4">
                <label for="input_description_1">
                    Descripción:
                </label>
                <textarea class="form-control" rows="4" v-model="data.input_description_1">
                </textarea>
                <div class="help-block" v-if="errors.input_description_1">
                    {{ errors.input_description_1 }}
                </div>
            </div>
            <!-- input_title_2 Field -->
            <div :class="{'has-error': errors.input_title_2}" class="form-group col-sm-4">
                <label for="input_title_2">
                    Título:
                </label>
                <input class="form-control" id="input_title_2" type="text" v-model="data.input_title_2">
                    <div class="help-block" v-if="errors.input_title_2">
                        {{ errors.input_title_2 }}
                    </div>
                </input>
            </div>
            <!-- input_button_2 Field -->
            <div :class="{'has-error': errors.input_button_2}" class="form-group col-sm-4">
                <label for="input_button_2">
                    Link:
                </label>
                <input class="form-control" id="input_button_2" type="text" v-model="data.input_button_2">
                    <div class="help-block" v-if="errors.input_button_2">
                        {{ errors.input_button_2 }}
                    </div>
                </input>
            </div>
            <!-- input_description_2 Field -->
            <div :class="{'has-error': errors.input_description_2}" class="form-group col-sm-4">
                <label for="input_description_2">
                    Descripción:
                </label>
                <textarea class="form-control" rows="4" v-model="data.input_description_2">
                </textarea>
                <div class="help-block" v-if="errors.input_description_2">
                    {{ errors.input_description_2 }}
                </div>
            </div>
            <!-- input_title_3 Field -->
            <div :class="{'has-error': errors.input_title_3}" class="form-group col-sm-4">
                <label for="input_title_3">
                    Título:
                </label>
                <input class="form-control" id="input_title_3" type="text" v-model="data.input_title_3">
                    <div class="help-block" v-if="errors.input_title_3">
                        {{ errors.input_title_3 }}
                    </div>
                </input>
            </div>
            <!-- input_button_3 Field -->
            <div :class="{'has-error': errors.input_button_3}" class="form-group col-sm-4">
                <label for="input_button_3">
                    Link:
                </label>
                <input class="form-control" id="input_button_3" type="text" v-model="data.input_button_3">
                    <div class="help-block" v-if="errors.input_button_3">
                        {{ errors.input_button_3 }}
                    </div>
                </input>
            </div>
            <!-- input_description_3 Field -->
            <div :class="{'has-error': errors.input_description_3}" class="form-group col-sm-4">
                <label for="input_description_3">
                    Descripción:
                </label>
                <textarea class="form-control" rows="4" v-model="data.input_description_3">
                </textarea>
                <div class="help-block" v-if="errors.input_description_3">
                    {{ errors.input_description_3 }}
                </div>
            </div>
        </div>
        <div id="components-2" v-if="showComponent == 'lp-components-text-image-right'">
            <div class="col-sm-12">
                <h4 class="panel-title">
                    Configuración para componente
                </h4>
                <hr/>
            </div>
            <!-- input_title_1 Field -->
            <div :class="{'has-error': errors.input_title_1}" class="form-group col-sm-4">
                <label for="input_title_1">
                    Título:
                </label>
                <input class="form-control" id="input_title_1" type="text" v-model="data.input_title_1">
                    <div class="help-block" v-if="errors.input_title_1">
                        {{ errors.input_title_1 }}
                    </div>
                </input>
            </div>
            <!-- input_image_1 Field -->
            <div :class="{'has-error': errors.input_image_1}" class="form-group col-sm-4">
                <label for="input_image_1">
                    Imagen:
                </label>
                <input class="form-control" id="input_image_1" type="file" v-on:change="onFileChange">
                    <div class="help-block" v-if="errors.input_image_1">
                        {{ errors.input_image_1 }}
                    </div>
                </input>
            </div>
            <!-- input_description_1 Field -->
            <div :class="{'has-error': errors.input_description_1}" class="form-group col-sm-4">
                <label for="input_description_1">
                    Descripción:
                </label>
                <textarea class="form-control" rows="4" v-model="data.input_description_1">
                </textarea>
                <div class="help-block" v-if="errors.input_description_1">
                    {{ errors.input_description_1 }}
                </div>
            </div>
        </div>
        <div id="components-3" v-if="showComponent == 'lp-components-text-image-left'">
            <div class="col-sm-12">
                <h4 class="panel-title">
                    Configuración para componente
                </h4>
                <hr/>
            </div>
            <!-- input_title_1 Field -->
            <div :class="{'has-error': errors.input_title_1}" class="form-group col-sm-4">
                <label for="input_title_1">
                    Título:
                </label>
                <input class="form-control" id="input_title_1" type="text" v-model="data.input_title_1">
                    <div class="help-block" v-if="errors.input_title_1">
                        {{ errors.input_title_1 }}
                    </div>
                </input>
            </div>
            <!-- input_image_1 Field -->
            <div :class="{'has-error': errors.input_image_1}" class="form-group col-sm-4">
                <label for="input_image_1">
                    Imagen:
                </label>
                <input class="form-control" id="input_image_1" type="file" v-on:change="onFileChange">
                    <div class="help-block" v-if="errors.input_image_1">
                        {{ errors.input_image_1 }}
                    </div>
                </input>
            </div>
            <!-- input_description_1 Field -->
            <div :class="{'has-error': errors.input_description_1}" class="form-group col-sm-4">
                <label for="input_description_1">
                    Descripción:
                </label>
                <textarea class="form-control" rows="4" v-model="data.input_description_1">
                </textarea>
                <div class="help-block" v-if="errors.input_description_1">
                    {{ errors.input_description_1 }}
                </div>
            </div>
        </div>
        <div id="components-4" v-if="showComponent == 'lp-components-text-image-background'">
            <div class="col-sm-12">
                <h4 class="panel-title">
                    Configuración para componente
                </h4>
                <hr/>
            </div>
            <!-- input_title_1 Field -->
            <div :class="{'has-error': errors.input_title_1}" class="form-group col-sm-6">
                <label for="input_title_1">
                    Título:
                </label>
                <input class="form-control" id="input_title_1" type="text" v-model="data.input_title_1">
                    <div class="help-block" v-if="errors.input_title_1">
                        {{ errors.input_title_1 }}
                    </div>
                </input>
            </div>
            <!-- input_image_1 Field -->
            <div :class="{'has-error': errors.input_image_1}" class="form-group col-sm-6">
                <label for="input_image_1">
                    Imagen:
                </label>
                <input class="form-control" id="input_image_1" type="file" v-on:change="onFileChange">
                    <div class="help-block" v-if="errors.input_image_1">
                        {{ errors.input_image_1 }}
                    </div>
                </input>
            </div>
        </div>
        <div id="components-5" v-if="showComponent == 'lp-components-2-text-button'">
            <div class="col-sm-12">
                <h4 class="panel-title">
                    Configuración para componente
                </h4>
                <hr/>
            </div>
            <!-- input_title_1 Field -->
            <div :class="{'has-error': errors.input_title_1}" class="form-group col-sm-4">
                <label for="input_title_1">
                    Título:
                </label>
                <input class="form-control" id="input_title_1" type="text" v-model="data.input_title_1">
                    <div class="help-block" v-if="errors.input_title_1">
                        {{ errors.input_title_1 }}
                    </div>
                </input>
            </div>
            <!-- input_button_1 Field -->
            <div :class="{'has-error': errors.input_button_1}" class="form-group col-sm-4">
                <label for="input_button_1">
                    Link:
                </label>
                <input class="form-control" id="input_button_1" type="text" v-model="data.input_button_1">
                    <div class="help-block" v-if="errors.input_button_1">
                        {{ errors.input_button_1 }}
                    </div>
                </input>
            </div>
            <!-- input_subtitle_1 Field -->
            <div :class="{'has-error': errors.input_subtitle_1}" class="form-group col-sm-4">
                <label for="input_subtitle_1">
                    Botón:
                </label>
                <input class="form-control" id="input_title_1" type="text" v-model="data.input_subtitle_1">
                    <div class="help-block" v-if="errors.input_subtitle_1">
                        {{ errors.input_subtitle_1 }}
                    </div>
                </input>
            </div>
        </div>

        <div id="components-6" v-if="showComponent == 'lp-components-full-info-image-right'">
            <div class="col-sm-12">
                <h4 class="panel-title">
                    Configuración para componente
                </h4>
                <hr/>
            </div>
            <!-- input_title_1 Field -->
            <div :class="{'has-error': errors.input_title_1}" class="form-group col-sm-6">
                <label for="input_title_1">
                    Título:
                </label>
                <input class="form-control" id="input_title_1" type="text" v-model="data.input_title_1">
                    <div class="help-block" v-if="errors.input_title_1">
                        {{ errors.input_title_1 }}
                    </div>
                </input>
            </div>
            <!-- input_subtitle_1 Field -->
            <div :class="{'has-error': errors.input_subtitle_1}" class="form-group col-sm-6">
                <label for="input_subtitle_1">
                    Subtítulo:
                </label>
                <input class="form-control" id="input_subtitle_1" type="text" v-model="data.input_subtitle_1">
                    <div class="help-block" v-if="errors.input_subtitle_1">
                        {{ errors.input_subtitle_1 }}
                    </div>
                </input>
            </div>
            <!-- input_button_1 Field -->
            <div :class="{'has-error': errors.input_button_1}" class="form-group col-sm-6">
                <label for="input_button_1">
                    Botón:
                </label>
                <input class="form-control" id="input_button_1" type="text" v-model="data.input_button_1">
                    <div class="help-block" v-if="errors.input_button_1">
                        {{ errors.input_button_1 }}
                    </div>
                </input>
            </div>
            <!-- input_link_1 Field -->
            <div :class="{'has-error': errors.input_link_1}" class="form-group col-sm-6">
                <label for="input_link_1">
                    Link:
                </label>
                <input class="form-control" id="input_link_1" type="text" v-model="data.input_link_1">
                    <div class="help-block" v-if="errors.input_link_1">
                        {{ errors.input_link_1 }}
                    </div>
                </input>
            </div>
            <!-- input_image_1 Field -->
            <div :class="{'has-error': errors.input_image_1}" class="form-group col-sm-6">
                <label for="input_image_1">
                    Imagen:
                </label>
                <input class="form-control" id="input_image_1" type="file" v-on:change="onFileChange">
                    <div class="help-block" v-if="errors.input_image_1">
                        {{ errors.input_image_1 }}
                    </div>
                </input>
            </div>
            <!-- input_description_1 Field -->
            <div :class="{'has-error': errors.input_description_1}" class="form-group col-sm-6">
                <label for="input_description_1">
                    Descripción:
                </label>
                <textarea class="form-control" rows="4" v-model="data.input_description_1">
                </textarea>
                <div class="help-block" v-if="errors.input_description_1">
                    {{ errors.input_description_1 }}
                </div>
            </div>
        </div>

        <!-- Submit Field -->
        <div class="form-group col-sm-12">
            <input class="btn btn-primary" type="submit" value="Guardar">
                <a class="btn btn-default" href="/backend/landing-pages-components-data">
                    Cancelar
                </a>
            </input>
        </div>
    </form>
</template>
<script>
    export default {
        data() {
            return {
                errors: {},
                data: [],
                components: [],
                showComponent: false
            }
        },
        mounted() {
            this.fetchComponents();
        },
        methods: {
            onFileChange(e){
                this.data.input_image_1 = e.target.files[0];
            },
            fetchComponents: function() {
                self = this

                axios({
                    url: 'backend/landing-pages-components-data/getcomponents',
                    method: 'GET',
                }).then(function(response){
                    self.components = response.data.components;
                    console.log(response)
                }).catch(function(error){
                    console.log(error);
                });
            },
            onChangeComponents: function () {
                this.showComponent = this.data.id_landing_pages_components.text;

                // inputs
                this.data.input_title_1 = undefined;
                this.data.input_title_2 = undefined;
                this.data.input_title_3 = undefined;
                this.data.input_subtitle_1 = undefined;
                this.data.input_subtitle_2 = undefined;
                this.data.input_subtitle_3 = undefined;
                this.data.input_image_1 = undefined;
                this.data.input_image_2 = undefined;
                this.data.input_image_3 = undefined;
                this.data.input_description_1 = undefined;
                this.data.input_description_2 = undefined;
                this.data.input_description_3 = undefined;
                this.data.input_button_1 = undefined;
                this.data.input_button_2 = undefined;
                this.data.input_button_3 = undefined;
                this.data.input_link_1 = undefined;
                this.data.input_link_2 = undefined;
                this.data.input_link_3 = undefined;
                // errors
                this.errors.input_title_1 = false;
                this.errors.input_title_2 = false;
                this.errors.input_title_3 = false;
                this.errors.input_subtitle_1 = false;
                this.errors.input_subtitle_2 = false;
                this.errors.input_subtitle_3 = false;
                this.errors.input_image_1 = false;
                this.errors.input_image_2 = false;
                this.errors.input_image_3 = false;
                this.errors.input_description_1 = false;
                this.errors.input_description_2 = false;
                this.errors.input_description_3 = false;
                this.errors.input_button_1 = false;
                this.errors.input_button_2 = false;
                this.errors.input_button_3 = false;
                this.errors.input_link_1 = false;
                this.errors.input_link_2 = false;
                this.errors.input_link_3 = false;
            },
            submit: function(){
                this.errors = {};
                // si campo nombre es vacío
                if(typeof(this.data.name) == undefined || this.data.name == '' || this.data.name == null) {
                    this.errors.name = "El campo Nombre es requerido";
                } else {
                    this.errors.name = false;
                }

                // si campo componente es vacío
                this.errors.id_landing_pages_components = null;
                if(typeof(this.data.id_landing_pages_components) == undefined || this.data.id_landing_pages_components == '' || this.data.id_landing_pages_components == null) {
                    this.errors.id_landing_pages_components = "El campo Componente es requerido";
                } else {
                    this.errors.id_landing_pages_components = false;
                }

                // para componentes
                if (this.showComponent == "lp-components-text-image-right" || this.showComponent == "lp-components-text-image-left") {
                    // campo titulo 1
                    if(typeof(this.data.input_title_1) == undefined || this.data.input_title_1 == '' || this.data.input_title_1 == null) {
                        this.errors.input_title_1 = "El campo Título es requerido";
                    } else {
                        this.errors.input_title_1 = false;
                    }
                    // campo imagen 1
                    if(typeof(this.data.input_image_1) == undefined || this.data.input_image_1 == '' || this.data.input_image_1 == null) {
                        this.errors.input_image_1 = "El campo Imagen es requerido";
                    } else {
                        this.errors.input_image_1 = false;
                    }
                    // campo descripción 1
                    if(typeof(this.data.input_description_1) == undefined || this.data.input_description_1 == '' || this.data.input_description_1 == null) {
                        this.errors.input_description_1 = "El campo Descripción es requerido";
                    } else {
                        this.errors.input_description_1 = false;
                    }
                } else if (this.showComponent == "lp-components-full-info-image-right") {
                    // campo titulo 1
                    if(typeof(this.data.input_title_1) == undefined || this.data.input_title_1 == '' || this.data.input_title_1 == null) {
                        this.errors.input_title_1 = "El campo Título es requerido";
                    } else {
                        this.errors.input_title_1 = false;
                    }
                    // campo subtitulo 1
                    if(typeof(this.data.input_subtitle_1) == undefined || this.data.input_subtitle_1 == '' || this.data.input_subtitle_1 == null) {
                        this.errors.input_subtitle_1 = "El campo Subtítulo es requerido";
                    } else {
                        this.errors.input_subtitle_1 = false;
                    }
                    // campo boton 1
                    if(typeof(this.data.input_button_1) == undefined || this.data.input_button_1 == '' || this.data.input_button_1 == null) {
                        this.errors.input_button_1 = "El campo Boton es requerido";
                    } else {
                        this.errors.input_button_1 = false;
                    }
                    // campo link 1
                    if(typeof(this.data.input_link_1) == undefined || this.data.input_link_1 == '' || this.data.input_link_1 == null) {
                        this.errors.input_link_1 = "El campo Boton es requerido";
                    } else {
                        this.errors.input_link_1 = false;
                    }
                    // campo imagen 1
                    if(typeof(this.data.input_image_1) == undefined || this.data.input_image_1 == '' || this.data.input_image_1 == null) {
                        this.errors.input_image_1 = "El campo Imagen es requerido";
                    } else {
                        this.errors.input_image_1 = false;
                    }
                    // campo descripción 1
                    if(typeof(this.data.input_description_1) == undefined || this.data.input_description_1 == '' || this.data.input_description_1 == null) {
                        this.errors.input_description_1 = "El campo Descripción es requerido";
                    } else {
                        this.errors.input_description_1 = false;
                    }
                } else if (this.showComponent == "lp-components-text-image-background") {
                    // campo titulo 1
                    if(typeof(this.data.input_title_1) == undefined || this.data.input_title_1 == '' || this.data.input_title_1 == null) {
                        this.errors.input_title_1 = "El campo Título es requerido";
                    } else {
                        this.errors.input_title_1 = false;
                    }
                    // campo imagen 1
                    if(typeof(this.data.input_image_1) == undefined || this.data.input_image_1 == '' || this.data.input_image_1 == null) {
                        this.errors.input_image_1 = "El campo Imagen es requerido";
                    } else {
                        this.errors.input_image_1 = false;
                    }
                } else if (this.showComponent == "lp-components-3-text-description") {
                    // campo titulo 1
                    if(typeof(this.data.input_title_1) == undefined || this.data.input_title_1 == '' || this.data.input_title_1 == null) {
                        this.errors.input_title_1 = "El campo Título es requerido";
                    } else {
                        this.errors.input_title_1 = false;
                    }
                    // campo link 1
                    if(typeof(this.data.input_button_1) == undefined || this.data.input_button_1 == '' || this.data.input_button_1 == null) {
                        this.errors.input_button_1 = "El campo Link es requerido";
                    } else {
                        this.errors.input_button_1 = false;
                    }
                    // campo descripcion 1
                    if(typeof(this.data.input_description_1) == undefined || this.data.input_description_1 == '' || this.data.input_description_1 == null) {
                        this.errors.input_description_1 = "El campo Imagen es requerido";
                    } else {
                        this.errors.input_description_1 = false;
                    }

                    // campo titulo 2
                    if(typeof(this.data.input_title_2) == undefined || this.data.input_title_2 == '' || this.data.input_title_2 == null) {
                        this.errors.input_title_2 = "El campo Título es requerido";
                    } else {
                        this.errors.input_title_2 = false;
                    }
                    // campo link 2
                    if(typeof(this.data.input_button_2) == undefined || this.data.input_button_2 == '' || this.data.input_button_2 == null) {
                        this.errors.input_button_2 = "El campo Link es requerido";
                    } else {
                        this.errors.input_button_2 = false;
                    }
                    // campo descripcion 2
                    if(typeof(this.data.input_description_2) == undefined || this.data.input_description_2 == '' || this.data.input_description_2 == null) {
                        this.errors.input_description_2 = "El campo Imagen es requerido";
                    } else {
                        this.errors.input_description_2 = false;
                    }

                    // campo titulo 3
                    if(typeof(this.data.input_title_3) == undefined || this.data.input_title_3 == '' || this.data.input_title_3 == null) {
                        this.errors.input_title_3 = "El campo Título es requerido";
                    } else {
                        this.errors.input_title_3 = false;
                    }
                    // campo link 3
                    if(typeof(this.data.input_button_3) == undefined || this.data.input_button_3 == '' || this.data.input_button_3 == null) {
                        this.errors.input_button_3 = "El campo Link es requerido";
                    } else {
                        this.errors.input_button_3 = false;
                    }
                    // campo descripcion 3
                    if(typeof(this.data.input_description_3) == undefined || this.data.input_description_3 == '' || this.data.input_description_3 == null) {
                        this.errors.input_description_3 = "El campo Imagen es requerido";
                    } else {
                        this.errors.input_description_3 = false;
                    }
                } else if (this.showComponent == "lp-components-2-text-button") {
                    // campo titulo 1
                    if(typeof(this.data.input_title_1) == undefined || this.data.input_title_1 == '' || this.data.input_title_1 == null) {
                        this.errors.input_title_1 = "El campo Título es requerido";
                    } else {
                        this.errors.input_title_1 = false;
                    }
                    // campo link 1
                    if(typeof(this.data.input_button_1) == undefined || this.data.input_button_1 == '' || this.data.input_button_1 == null) {
                        this.errors.input_button_1 = "El campo Link es requerido";
                    } else {
                        this.errors.input_button_1 = false;
                    }
                    // campo Boton 1
                    if(typeof(this.data.input_subtitle_1) == undefined || this.data.input_subtitle_1 == '' || this.data.input_subtitle_1 == null) {
                        this.errors.input_subtitle_1 = "El campo Botón es requerido";
                    } else {
                        this.errors.input_subtitle_1 = false;
                    }
                }

                var form_component = true;
                for (const error in this.errors) {
                    if (this.errors[error] != false) {
                        form_component = false;
                        break;
                    }
                }

                // Si formulario es válido
                if (!this.errors.name && !this.errors.id_landing_pages_components && form_component) {
                    if (!this.data.active){
                        this.data.active = 0;
                    }

                    const config = {
                        headers: {
                            'content-type': 'multipart/form-data',
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        }
                    }

                    let params = new FormData();
                    params.append('name', this.data.name);
                    params.append('id_landing_pages_components', this.data.id_landing_pages_components.id);
                    params.append('active', this.data.active);
                    params.append('input_title_1', this.data.input_title_1);
                    params.append('input_title_2', this.data.input_title_2);
                    params.append('input_title_3', this.data.input_title_3);
                    params.append('input_subtitle_1', this.data.input_subtitle_1);
                    params.append('input_subtitle_2', this.data.input_subtitle_2);
                    params.append('input_subtitle_3', this.data.input_subtitle_3);
                    params.append('input_image_1', this.data.input_image_1);
                    params.append('input_image_2', this.data.input_image_2);
                    params.append('input_image_3', this.data.input_image_3);
                    params.append('input_description_1', this.data.input_description_1);
                    params.append('input_description_2', this.data.input_description_2);
                    params.append('input_description_3', this.data.input_description_3);
                    params.append('input_button_1', this.data.input_button_1);
                    params.append('input_button_2', this.data.input_button_2);
                    params.append('input_button_3', this.data.input_button_3);
                    params.append('input_link_1', this.data.input_link_1);
                    params.append('input_link_2', this.data.input_link_2);
                    params.append('input_link_3', this.data.input_link_3);

                    axios.post('/backend/landing-pages-components-data', params, config)
                        .then((response) => {
                            // console.log(response);
                            window.location.replace(response.data.redirect);
                        });
                }
            }
        }
    }
</script>
